import { useEffect, useRef } from 'react';

/**
 * Roept `onVisible` aan zodra het tabblad weer zichtbaar wordt.
 *
 * De webtegenhanger van useAppResume, dat op het web niet vuurt. In de app kan dit naast
 * useAppResume ook vuren; een extra keer verversen kost dan één verzoek.
 */
export const useVisibleAgain = (onVisible: () => void): void => {
  // Via een ref, zodat de aanroeper zijn callback niet in useCallback hoeft te wikkelen.
  const callbackRef = useRef(onVisible);
  callbackRef.current = onVisible;

  useEffect(() => {
    const bijZichtbaar = () => {
      if (document.visibilityState === 'visible') callbackRef.current();
    };
    document.addEventListener('visibilitychange', bijZichtbaar);
    return () => document.removeEventListener('visibilitychange', bijZichtbaar);
  }, []);
};
